import { Box } from "@mui/material";
import styled from "styled-components";

interface IStyledContainer {}

const StyledContainer = styled(Box)<IStyledContainer>`
    padding: 16px;
    background-color: ${(props) => props.theme.mainBackground};
    color: ${(props) => props.theme.textPrimary};

    @media (max-width: 768px) {
        padding: 8px;
    }
`;

export default StyledContainer;
